import {initThreeIphonesRow} from "../components/three-iphones";

export function initTransgruzLanding() {
    if (!$('#transgruz_landing').length) return;
    $(window).on("load", function () {

        initThreeIphonesRow()
    });
}
